import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = {
  class: "tab-content",
  id: "myTabContent3"
}
const _hoisted_4 = {
  class: "tab-pane fade",
  id: "code3-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "code3-tab",
  tabindex: "0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "fs-18 mb-4" }, "Rounded Pill Badges", -1)),
      _cache[4] || (_cache[4] = _createElementVNode("ul", {
        class: "nav nav-tabs mb-4",
        id: "myTab3",
        role: "tablist"
      }, [
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link active",
            id: "preview3-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#preview3-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "preview3-tab-pane",
            "aria-selected": "true"
          }, " Preview ")
        ]),
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link",
            id: "code3-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#code3-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "code3-tab-pane",
            "aria-selected": "false"
          }, " Code ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("div", {
          class: "tab-pane fade show active",
          id: "preview3-tab-pane",
          role: "tabpanel",
          "aria-labelledby": "preview3-tab",
          tabindex: "0"
        }, [
          _createElementVNode("span", { class: "badge text-bg-primary py-1 px-2 me-1 text-white rounded-pill fw-medium fs-12" }, "Primary"),
          _createElementVNode("span", { class: "badge text-bg-secondary py-1 px-2 me-1 text-white rounded-pill fw-medium fs-12" }, "Secondary"),
          _createElementVNode("span", { class: "badge text-bg-success py-1 px-2 me-1 text-white rounded-pill fw-medium fs-12" }, "Success"),
          _createElementVNode("span", { class: "badge text-bg-danger py-1 px-2 me-1 text-white rounded-pill fw-medium fs-12" }, "Danger"),
          _createElementVNode("span", { class: "badge text-bg-warning py-1 px-2 me-1 text-white rounded-pill fw-medium fs-12" }, "Warning"),
          _createElementVNode("span", { class: "badge text-bg-info py-1 px-2 me-1 text-white rounded-pill fw-medium fs-12" }, "Info"),
          _createElementVNode("span", { class: "badge text-bg-light py-1 px-2 me-1 text-white rounded-pill fw-medium fs-12" }, "Light"),
          _createElementVNode("span", { class: "badge text-bg-dark py-1 px-2 me-1 text-white rounded-pill fw-medium fs-12" }, "Dark")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyCode && _ctx.copyCode(...args)))
          }, " Copy "),
          _cache[1] || (_cache[1] = _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
            _createTextVNode(""),
            _createElementVNode("code", {
              class: "language-markup",
              id: "codeCopy"
            }, "\n<button type=\"button\" class=\"btn bg-primary bg-opacity-10 fw-medium text-primary py-2 px-4 mt-2 me-2\">Primary</button>\n<button type=\"button\" class=\"btn bg-secondary bg-opacity-10 fw-medium text-secondary py-2 px-4 mt-2 me-2\">Secondary</button>\n<button type=\"button\" class=\"btn bg-success bg-opacity-10 fw-medium text-success py-2 px-4 mt-2 me-2\">Success</button>\n<button type=\"button\" class=\"btn bg-danger bg-opacity-10 fw-medium text-danger py-2 px-4 mt-2 me-2\">Danger</button>\n<button type=\"button\" class=\"btn bg-warning bg-opacity-10 fw-medium text-warning py-2 px-4 mt-2 me-2\">Warning</button>\n<button type=\"button\" class=\"btn bg-info bg-opacity-10 fw-medium text-info py-2 px-4 mt-2 me-2\">Info</button>\n<button type=\"button\" class=\"btn bg-light bg-opacity-10 fw-medium text-light py-2 px-4 mt-2 me-2\">Light</button>\n<button type=\"button\" class=\"btn bg-dark bg-opacity-10 fw-medium text-dark py-2 px-4 mt-2 me-2\">Dark</button>\n<button type=\"button\" class=\"btn bg-link bg-opacity-10 fw-medium text-link py-2 px-4 mt-2 me-2\">Link</button>\n"),
            _createTextVNode("\n")
          ], -1))
        ])
      ])
    ])
  ]))
}